// Common functionnalities for parent component using map components
// @see ApthAroundMeWidget.vue
// @see ApthOnStopWidget.vue

export default {
  data() {
    return {
      intervalVehiculeId: null,
      currentStopStorageKey: `${this.gtfsUri}-${this.network}-current-stop`,
    }
  },
  props: {
    themeUrl: {
      type: String,
      required: false,
      default: () => {
        return "//server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}";
      },
    },
    themeAttribution: {
      type: String,
      required: false,
      default: () => { return ""; },
    },
    displayVehiculePosition: {
      type: Boolean,
      required: false,
      default: true,
    },
    updateBusPositionDelay: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  mounted() {
    if (this.displayVehiculePosition && this.updateBusPositionDelay && this.updateBusPositionDelay != 0) {
      let delay = this.updateBusPositionDelay * 1000;
      // Set automatic bus position update
      this.intervalVehiculeId = setInterval(() => this.updateBusPosition(), delay);
    }
  },
  beforeDestroy() {
    if (this.intervalVehiculeId) {
      // Make sure we have not old interval remain actives
      clearInterval(this.intervalVehiculeId);
    }
  },
  computed: {
  },
  methods: {

    getVehiculeType() {
      let lineType = "3";// bus by default
      let line = this.lines[this.line];
      if (line) {
        lineType = line.lineType;
      }
      return lineType;
    },
    setLastStopStorage(stop) {
      localStorage.setItem(this.currentStopStorageKey, JSON.stringify(stop));
    },
    getLastStopStorage() {
      return localStorage.getItem(this.currentStopStorageKey);
    },
  }
}
